import { createSlice } from "@reduxjs/toolkit";


const SettingSlice = createSlice({
  name: "settings",
  initialState: {
    loading: false,
    error: null,
    generalSettings: {
      uiid: null,
      raSettings: {
        companySettings: {
          activeGmail: null,
        },
        localRestrictions: [],
      },
      bdmSettings: {
        jobInactivityLimitDays: null,
        addedBy: null
      },
      recruitmentSettings: {
        monsterCreditAssign: null
      }
    },
    accessControls: {
      userTeams: {
        users: [],
      },
      security: {
        roles: [],
      }
    },
    companyProfile: {
      localInfo: {
        coOps: "",
        currency: "",
        timezone: null,
        timeFormat: null,
      },
      generalDetails: {
        companyName: "",
        displayName: "",
        website: "",
        companyContact: "",
        panNumber: "",
        description: "",
      },
    },
    configurations: {
      integrations: {
        JobBoardDetails: [],
      }
    },
    branding: {
      company: null,
      social: null
    },
    allIntegrationData: {
      data: []
    },
    raAddedLocations: {
      data: []
    },
      bdmAddedLocations: {
      data: []
    }

  },
  reducers: {
    setActiveGmailStart(state) {
      state.loading = true;
      state.error = null;
    },
    setActiveGmailSuccess(state, action) {
      state.loading = false;
      state.generalSettings.raSettings.companySettings.activeGmail = action.payload;
    },
    setActiveGmailFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearActiveGmail(state) {
      state.generalSettings.raSettings.companySettings.activeGmail = null;
      state.error = null;
      state.loading = false;
    },
    // USERS 
    getUsersStart(state) {
      state.loading = true;
      state.error = null;
    },
    getUsersSuccess(state, action) {
      state.loading = false;
      state.accessControls.userTeams.users = action.payload || [];
    },

    getUsersFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    // ROLES
    getRolesStart(state) {
      state.loading = true;
      state.error = null;
    },
    getRolesSuccess(state, action) {
      state.loading = false;
      state.accessControls.security.roles = action.payload || [];
    },
    getRolesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    // LOCAL INFO
    getLocalInfoStart(state) {
      state.loading = true;
      state.error = null;
    },
    getLocalInfoSuccess(state, action) {
      state.loading = false;
      state.companyProfile.localInfo = action.payload;
    },
    getLocalInfoFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setLocalInfoStart(state) {
      state.loading = true;
      state.error = null;
    },
    setLocalInfoSuccess(state, action) {
      state.loading = false;
      state.companyProfile.localInfo = action.payload;
    },
    setLocalInfoFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    // JOB BOARD DETAILS (POST)
    saveJobBoardDetailsStart(state) {
      state.loading = true;
      state.error = null;
    },
    saveJobBoardDetailsSuccess(state, action) {
      state.loading = false;
      state.configurations.integrations.JobBoardDetails.push(action.payload);
    },
    saveJobBoardDetailsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    // --- SAVE COMPANY DETAILS ---
    saveCompanyDetailsStart(state) {
      state.loading = true;
      state.error = null;
    },
    saveCompanyDetailsSuccess(state, action) {
      state.loading = false;
      state.companyProfile.generalDetails = action.payload;
    },
    saveCompanyDetailsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    // COMPANY GENERAL DETAILS
    getCompanyDetailsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getCompanyDetailsSuccess(state, action) {
      state.loading = false;
      state.companyProfile.generalDetails = action.payload;
    },
    getCompanyDetailsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    organizationImageUploadStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    organizationImageUploadSuccess: (state, action) => {
      state.loading = false;
      state.branding = action.payload;
    },
    organizationImageUploadFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    getBrandingImageStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getBrandingImageSuccess: (state, action) => {
      // console.log("getBrandingImageSuccess", action.payload)
      state.loading = false;
      state.branding = action.payload;
    },
    getBrandingImageFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Local restrictions
    getLocalRestrictionStart: (state, action) => {
      state.loading = true;
      state.error = false;
    },
    getLocalRestrictionSuccess: (state, action) => {
      state.loading = false;
      state.generalSettings.raSettings.localRestrictions = action.payload;
    },
    getLocalRestrictionFailure: (state, action) => {
      state.generalSettings.raSettings.localRestrictions = [];
      state.error = action.error;
    },
    setBdmSettings(state, action) {
      state.generalSettings.bdmSettings = action.payload?.[0]?.bdmSettings;
    },
    getAllIntegrationsStart: (state, action) => {
      state.loading = true;
      state.error = false;
    },
    getAllIntegrationsSuccess: (state, action) => {
      state.loading = false;
      state.allIntegrationData.data = action.payload;
    },
    getAllIntegrationsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getRALocationsStart: (state, action) => {
      state.loading = true;
      state.error = false;
    },
    getRALocationsSuccess: (state, action) => {

      state.loading = false;
      state.raAddedLocations.data = action.payload;
    },
    getRALocationsFailure: (state, action) => {
      state.loading = false;
      state.error = false;
    },
    getBDMLocationsStart: (state, action) => {
      state.loading = true;
      state.error = false;
    },
    getBDMLocationsSuccess: (state, action) => {

      state.loading = false;
      state.bdmAddedLocations.data = action.payload;
    },
    getBDMLocationsFailure: (state, action) => {
      state.loading = false;
      state.error = false;
    },
    getRecruitmentSettingsStart: (state, action) => {
      state.loading= true;
    },
    getRecruitmentSettingsSuccess: (state, action) => {
      state.loading = false;
      state.generalSettings.recruitmentSettings = action.payload?.[0]?.recruitmentSettings;
      state.generalSettings.uiid = action.payload?.[0]?.uiid
    },
    getRecruitmentSettingsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  },
});

export const {
  setActiveGmailStart,
  setActiveGmailSuccess,
  setActiveGmailFailure,
  clearActiveGmail,
  getUsersStart,
  getUsersSuccess,
  getUsersFailure,
  getRolesStart,
  getRolesSuccess,
  getRolesFailure,
  setLocalInfoStart,
  setLocalInfoSuccess,
  setLocalInfoFailure,
  getLocalInfoStart,
  getLocalInfoSuccess,
  getLocalInfoFailure,
  saveJobBoardDetailsStart,
  saveJobBoardDetailsSuccess,
  saveJobBoardDetailsFailure,
  saveCompanyDetailsStart,
  saveCompanyDetailsSuccess,
  saveCompanyDetailsFailure,
  getCompanyDetailsStart,
  getCompanyDetailsSuccess,
  getCompanyDetailsFailure,
  organizationImageUploadStart,
  organizationImageUploadSuccess,
  organizationImageUploadFailure,
  getBrandingImageStart,
  getBrandingImageSuccess,
  getBrandingImageFailure,
  getLocalRestrictionStart,
  getLocalRestrictionSuccess,
  getLocalRestrictionFailure,
  setBdmSettings,
  getAllIntegrationsStart,
  getAllIntegrationsSuccess,
  getAllIntegrationsFailure,
  getRALocationsStart,
  getRALocationsSuccess,
  getRALocationsFailure,
      getBDMLocationsStart,
  getBDMLocationsSuccess,
  getBDMLocationsFailure,
  getRecruitmentSettingsStart,
  getRecruitmentSettingsSuccess,
  getRecruitmentSettingsFailure
} = SettingSlice.actions;

export default SettingSlice.reducer;
